import { computed, ref } from 'vue'

import {
  useUpdateAccountBioMutation,
  type User,
} from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

export function useChangeBio(user: User) {
  const toastStore = useToastStore()
  const webviewStore = useWebviewStore()

  const bio = ref(user.bio || '')

  const { mutate: updateAccountBio, loading } = useUpdateAccountBioMutation()

  const canSave = computed(() => bio.value.trim() !== (user.bio || '').trim())

  const save = async () => {
    if (!canSave.value) return false

    updateAccountBio(
      { bio: bio.value },
      {
        optimisticResponse: {
          __typename: 'Mutation',
          updateAccountBio: {
            __typename: 'User',
            id: user.id,
            bio: bio.value,
          },
        },
        update() {
          if (!webviewStore.isActive) return

          webviewStore.postMessage({
            type: NativeActionsEnum.UserUpdated,
            data: { user: { ...user, bio: bio.value } },
          })
        },
      }
    )

    toastStore.showToast({
      type: ToastType.Success,
      content: 'Your bio has been updated',
    })

    return true
  }

  return { bio, loading, canSave, save }
}
